import { redirect, ActionFunctionArgs, LoaderFunctionArgs } from "react-router-dom";
import { myAxios } from "../../common/functions";
export async function createFormAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const payloadRaw = formData.get("payload");
    if(!payloadRaw){
        throw new Response("Missing payload", { status: 400 });
    }
    const payload = JSON.parse(payloadRaw as string);
    const fd = new FormData();
    fd.append("data", JSON.stringify(payload));
    const res = await myAxios({
        fileName: "forms/createForm.php",
        formData: fd,
        signal: controller.signal
    });
    if(!res) return;
    throw redirect(`/Forms/Setting/${res.data.id}`);
}
export async function deleteFormAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const formId = formData.get("formId");
    if (!formId) {
        throw new Response("Missing formId", { status: 400 });
    }
    const fd = new FormData();
    fd.append("id", String(formId));
    const res = await myAxios({
        fileName: "forms/deleteForm.php",
        formData: fd, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}
export async function updateFormAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const payloadRaw = formData.get("payload");
    if(!payloadRaw){
        throw new Response("Missing payload", { status: 400 });
    }
    let payload: any;
    try{
        payload = JSON.parse(payloadRaw as string);
    }catch{
        throw new Response("Invalid payload JSON", { status: 400 });
    }
    if(!payload.form || !payload.form.id) {
        throw new Response("Missing form id", { status: 400 });
    }
    const fd = new FormData();
    fd.append("data", JSON.stringify(payload));
    const res = await myAxios({
        fileName: "forms/updateForm.php",
        formData: fd, 
        signal: controller.signal
    });
    if(!res) return;
    throw redirect(`/Forms/Setting/${payload.form.id}`);
}
export async function formsLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const status = url.searchParams.get("status") ?? ""; // draft | published
    const type = url.searchParams.get("type") ?? "";
    const pageParam = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    let shouldRedirect = false;
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const formData = new FormData();
    if (status) formData.append("status", status);
    if (type) formData.append("type", type);
    formData.append("page", String(page));
    formData.append("limit", String(limit));
    const res = await myAxios({
        fileName: "forms/readForms.php",
        formData, 
        signal: controller.signal
    });
    if (!res) throw redirect("..");
    const { items, total } = res.data;
    return {
        forms: items,
        total
    };
}
export async function formLoader({ request, params }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    if(!id){
        throw new Response("Missing form id", { status: 400 });
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "forms/readForm.php",
        formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    return res.data;
}